import React from 'react';

import {
	Icon,
	IconAttention,
	IconCheckmark,
	IconCheckmarkStrong,
	IconTime,
	IconTimetable,
} from '@flixbus/honeycomb-icons-react';

const statusMap = {
	created: <Icon InlineIcon={IconTime} size={3} aria-label="IconTime" />,
	pending: <Icon InlineIcon={IconTime} size={3} aria-label="IconTime" />,
	planned: <Icon InlineIcon={IconTimetable} size={3} aria-label="IconTimetable" />,
	actual: <Icon InlineIcon={IconTime} size={3} aria-label="IconTime" />,
	confirmed: <Icon InlineIcon={IconCheckmark} size={3} aria-label="IconCheckmark" />,
	completed: <Icon InlineIcon={IconTime} size={3} aria-label="IconTime" />,
	rejected: <Icon InlineIcon={IconAttention} size={3} aria-label="IconAttention" />,
	inProgress: <Icon InlineIcon={IconCheckmarkStrong} size={3} aria-label="IconCheckmarkStrong" />,
};

const StatusIcon = ({ status }) => {
	return statusMap[status];
};

export default StatusIcon;
